import { render, staticRenderFns } from "./DialogDetailPeriod.vue?vue&type=template&id=05ccbdeb"
import script from "./DialogDetailPeriod.vue?vue&type=script&lang=js"
export * from "./DialogDetailPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports